export default {"src":"/fly/_next/static/media/chevron-right-icon.b7b5a275.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};